import I18n from 'I18n';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import * as api from 'web-interactives-data/api/campaigns';
import { getCampaignUrl } from 'web-interactives-data/utils/urlUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const CampaignName = ({
  guid,
  showAsLink
}) => {
  const defaultName = guid ? '' : I18n.text('campaigns.noCampaign');
  const [campaignNames, setCampaignNames] = useState({});
  const campaignName = guid && campaignNames[guid] || defaultName;
  const [isLoading, setLoading] = useState(false);
  useEffect(() => {
    if (isLoading || !guid) return;
    if (!campaignName) {
      setLoading(true);
      api.getCampaignName(guid).then(name => {
        setCampaignNames(Object.assign({}, campaignNames, {
          [guid]: name
        }));
        setLoading(false);
      }).catch(err => {
        setLoading(false);
        console.error(err);
      });
    }
  }, [campaignName, campaignNames, guid, isLoading]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "extra-small"
    });
  }
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": "campaign-name",
    children: showAsLink && guid ? /*#__PURE__*/_jsx(Link, {
      external: true,
      href: getCampaignUrl(guid),
      children: campaignName
    }) : campaignName
  });
};
CampaignName.propTypes = {
  guid: PropTypes.string
};
export default CampaignName;